import { Component, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { Subscription, Observable } from 'rxjs'
import { UiService } from 'src/app/services/ui.service'
import { subscriptionActive } from 'src/utils/rxjs-utils'
import { AccountService } from '../../services/account.service'
import { ModalDialogComponent } from 'src/app/shared/modal-dialog/modal-dialog.component'
import { ApiService } from 'src/app/services/api.service'
import { AccessLevelService } from 'src/app/services/access-level.service'
import { FormValidationService } from 'src/app/services/form-validation.service'
import { RoleDto } from 'src/app/services/dtos'
import { BaseRoleModal, ApplicationItem, PolicyChild } from '../shared/base-role-modal'
import { ModalService, ModalController } from '../../services/modal.service'

@Component({
  selector: 'app-new-role-modal',
  templateUrl: './new-role-modal.component.html',
  standalone: false,
})
export class NewRoleModalComponent extends BaseRoleModal implements OnDestroy, ModalController {
  @ViewChild('newRoleModal') modal: ModalDialogComponent
  @Output() roleCreated = new EventEmitter<void>()

  constructor(
    protected formBuilder: FormBuilder,
    protected accountService: AccountService,
    protected uiService: UiService,
    protected apiService: ApiService,
    protected accessLevelService: AccessLevelService,
    protected formValidationService: FormValidationService,
    private modalService: ModalService
  ) {
    super(formBuilder, accountService, apiService, uiService, accessLevelService, formValidationService)
    // Set policies to default open in create modal
    this.defaultPolicyCollapsed = false
    // Register with modal service
    this.modalService.register(this, this)
  }

  ngOnDestroy() {
    this.cleanup()
    // Unregister from modal service
    this.modalService.unregister(this)
  }

  // Abstract method implementations
  getSaveButtonText(): string {
    return this.saving ? 'Creating...' : 'Create Role'
  }

  performSave(rolePayload: any): Observable<any> {
    return this.apiService.createRole(this.accountService.accountId, rolePayload as any)
  }

  onSaveSuccess(result: RoleDto): void {
    this.roleCreated.emit()
    this.close()
  }

  open() {
    this.modal.open()
    this.loadAvailableApplications()
    this.resetForm()
  }

  close() {
    this.modal.close()
    this.resetForm()
  }

  isModalOpen(): boolean {
    return this.modal && this.modal.isOpen
  }

  private resetForm() {
    this.roleForm.reset()
    this.resetSelections()
    // Add first policy child by default
    this.addPolicyChild()
    this.saving = false
    this.cleanup()
  }

  onCreateRole() {
    this.onSave() // Use the base class save method
  }
}
